import React from 'react';

import Typography, { TypographyProps } from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  root: {
    fontWeight: 700,
    lineHeight: 1.2,
  },
});

export type FeatureTitleProps = {
  children: React.ReactNode;
  component?: React.ElementType;
  className?: string;
  noWrap?: boolean;
  id?: string;
} & Pick<TypographyProps, 'variant'>;

/** Primary page / subject heading — bold h5 used in On Go and exercise sidebars. */
const FeatureTitle: React.FC<FeatureTitleProps> = ({
  children,
  component = 'h1',
  className,
  noWrap,
  id,
  variant = 'h5',
}) => {
  const { classes, cx } = useStyles();

  return (
    <Typography className={cx(classes.root, className)} component={component} id={id} noWrap={noWrap} variant={variant}>
      {children}
    </Typography>
  );
};

export default FeatureTitle;
